<template>
  <el-dialog
    :visible.sync="showTip"
    width="440px"
    :close-on-click-modal="false"
    :before-close="closeTip"
    top="24vh"
  >
  <div class="tip_wrap">
    <img src="@/assets/images/common/warning.png" alt="">
    <p v-html ="tipMsg" style="text-align:center; line-height:1.6em;"></p>
    <div class="dialog_btn_wrap">
      <el-button type="primary"  style="margin-right: .2rem" @click="closeTip(1)">{{confirmBtn ? confirmBtn : $t('confirm') }}</el-button>
      <el-button v-if="!confirmBtn" type="danger" @click="closeTip">{{$t('cancel')}}</el-button>
    </div>
  </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    showTip: {
      type: Boolean,
      required: true
    },
    tipMsg: {
      type: String,
      default: '确定进行此操作么？'
    },
    confirmBtn: {
      type: String
    }
  },
  methods: {
    closeTip (val) {
      if (val === 1) {
        this.$emit('callback', true)
      } else {
        this.$emit('callback', false)
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
  .tip_wrap
    width 100%
    display flex
    flex-direction column
    align-items center
    p
      font-size .18rem
      color #606266
      padding .2rem 0
      img
        width 1.03rem
        height .88rem
</style>
